<script>
import { deleteWRPDraft, getAllExistingWRPDates, getLocalDateString, getWRPDraft } from '@/services/WeeklyReviewPreviewServices';
export default {
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      loading: true,
      //
      startButtonText: 'Start a New WRP',
      allWRPDates: null,
    };
  },
  computed: {
    wrpDates() {
      return Object.keys(this.allWRPDates).sort((a, b) => b.localeCompare(a));
    },
  },
  methods: {
    getLocalDateFromString(dateString) {
      if ( typeof dateString !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(dateString) ) {
        return null;
      }

      const [year, month, day] = dateString.split('-').map(Number);

      const date = new Date(year, month - 1, day);

      // Reject invalid dates such as '2026-02-31'.
      if ( date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day ) {
        return null;
      }

      return date;
    },

    isDraftExpired(draft) {
      if (!draft?.updatedAt) {
        return true;
      }

      const updatedAtDate = this.getLocalDateFromString(draft.updatedAt);

      const todayDate = this.getLocalDateFromString(getLocalDateString());

      if (!updatedAtDate || !todayDate) {
        return true;
      }

      const millisecondsPerDay = 24 * 60 * 60 * 1000;

      const ageInDays = Math.floor( (todayDate.getTime() - updatedAtDate.getTime()) / millisecondsPerDay );

      // "More than 3 days ago":
      // age 0–3 = valid, age 4+ = expired.
      return ageInDays > 3;
    },
  },
  async created() {
    console.clear();
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    const what = await getAllExistingWRPDates(this.uId, this.token);
    if (what) {
      this.allWRPDates = what;
    }

    const draft = await getWRPDraft(this.uId, this.token);

    if (draft) {
      if (this.isDraftExpired(draft)) {
        await deleteWRPDraft(this.uId, this.token);
      } else {
        this.startButtonText = 'Continue WRP';
      }
    }

    this.loading = false;

  },
}
</script>

<template>

<div id="page-wrp-all" class="pa-4">
  <h1 class="my-4 text-center">
    <b>ALL</b>
    <br /><i>W</i>eekly <i>R</i>eview / <i>P</i>review's
    <br />(WRP)
  </h1>

  <div v-if="loading" class="py-8 d-flex justify-center align-center">
    <v-progress-circular :size="100" width="8" color="green-lighten-3" indeterminate></v-progress-circular>
  </div>


  <div v-else id="wrp-all-content">

    <!-- BUTTON: Start / Continue WRP -->
    <div class="d-flex justify-center pt-8 pb-16 mx-auto">
      <a href="/wrp">
        <v-btn color="green-lighten-1">{{ startButtonText }}</v-btn>
      </a>
    </div>

    <!-- LIST: All WRP's -->
    <div class="d-flex flex-column align-center">

      <h2 class="">Past WRP's</h2>
      <p class="text-body-2 mb-7"><i>newest to oldest</i></p>
      <ol v-if="allWRPDates">
        <li v-for="d in wrpDates" :key="d" class="mb-6">
          <router-link :to="`/wrp/${d}`" class="ps-3 text-blue-darken-3 text-decoration-none">{{d}}</router-link>
        </li>
      </ol>
    </div>

  </div> <!-- end #wrps-all-content -->

</div>
</template>

<style scoped lang="scss">
#page-wrp-all {
  @media screen and (min-width: 768px) {
    padding-left: 0;
    padding-right: 0;
    margin: 0 auto;
    width: 600px;
    max-width: 600px;
  }

  h1 i { letter-spacing: 3px; }
}
</style>
